import moment from "moment";

export const inventoryFormDefaultValues = {
  modelCode: '',
  orderNo: '',
  shipTo: '',
  reasonForOrder: '',
  locationStatus: '',
  dealerId: '',
  offlineDate: '',
  fhiDeparture: '',
  vesselEta: '',
}

export const parseLegacyVehicleInfo = (vehicleForm) => ({
  year: vehicleForm.year ? `${vehicleForm.year}` : undefined,
  make: vehicleForm.make,
  trim: vehicleForm.trim,
  plate: vehicleForm.plate,
  tag: vehicleForm.tag,
  km: vehicleForm.km ? `${vehicleForm.km}` : undefined,

  oemId: vehicleForm.oem_id ? `${vehicleForm.oem_id}` : undefined,
  shId: vehicleForm.sh_id ? `${vehicleForm.sh_id}` : undefined,
  vmhId: vehicleForm.vmh_id ? `${vehicleForm.vmh_id}` : undefined,
  star: vehicleForm.star ? `${vehicleForm.star}` : undefined,

  engine: vehicleForm.engine ? `${vehicleForm.engine}` : undefined,
  tires: vehicleForm.tires ? `${vehicleForm.tires}` : undefined,
  transmission: vehicleForm.transmission ? `${vehicleForm.transmission}` : undefined,
  driveTrain: vehicleForm.drive_train ? `${vehicleForm.drive_train}` : undefined,
  roof: vehicleForm.roof ? `${vehicleForm.roof}` : undefined,
  bodyStyle: vehicleForm.body_style ? `${vehicleForm.body_style}` : undefined,
  keys: vehicleForm.keys,

  warrantyDate: vehicleForm.warranty_date,
  retireDate: vehicleForm.retire_date,
  availableDate: vehicleForm.available_date,
  description: vehicleForm.description,
  accessories: vehicleForm.accessories,
  // fuel: vehicleForm.fuel,
  // isNewModel: vehicleForm.is_new_model,
  // isPrototype: vehicleForm.is_prototype,
  // isRedesign: vehicleForm.is_redesign,
});

export const parseCreateInventoryInput = (vehicleForm, legacyVehicleInfo, inventoryForm, clientCode, createdBy) => {
  const additionalData = [
    { name: 'licensePlate', value: vehicleForm.plate },
    { name: 'reasonForOrder', value: inventoryForm.reasonForOrder },
    { name: 'shipTo', value: inventoryForm.shipTo },

    { name: 'photoId', value: inventoryForm.photoId },
    { name: 'specSheetId', value: inventoryForm.specSheetId },
  ];

  // filter out empty values
  const filteredAdditionalData = additionalData.filter(({ value }) => value);

  return {
    clientCode,
    createdBy,
    dealerId: inventoryForm.dealerId,
    locationStatus: inventoryForm.locationStatus,
    vehicleType: vehicleForm.model,
    modelTrim: inventoryForm.modelCode,
    vin: vehicleForm.vin, // "4S3BWDE66N3002630"
    exteriorColor: vehicleForm.exterior_exact_color,
    interiorColor: vehicleForm.interior_exact_color,
    color: vehicleForm.exterior_exact_color,
    orderNo: inventoryForm.orderNo,
    offlineDate: moment(inventoryForm.offlineDate, 'MM-DD-YYYY').isValid() ? moment(inventoryForm.offlineDate, "MM-DD-YYYY").format("YYYY-MM-DD") : undefined,
    fhiDeparture: moment(inventoryForm.fhiDeparture, 'MM-DD-YYYY').isValid() ? moment(inventoryForm.fhiDeparture, "MM-DD-YYYY").format("YYYY-MM-DD") : undefined,
    vesselEta: moment(inventoryForm.vesselEta, 'MM-DD-YYYY').isValid() ? moment(inventoryForm.vesselEta, "MM-DD-YYYY").format("YYYY-MM-DD") : undefined,
    vehicleInfo: legacyVehicleInfo,
    additionalData: filteredAdditionalData,
  }
};

export const parseInventoryToLegacyVehicleForm = (inventory, currentOemId, currentShId) => ({
  year: inventory.vehicleInfo?.year,
  make: inventory.vehicleInfo?.make,
  trim: inventory.vehicleInfo?.trim,
  model: inventory.vehicleType,
  vin: inventory.vin,
  plate: inventory.additionalData.find(({ name }) => name === 'licensePlate')?.value,

  photoUrl: inventory.additionalData.find(({ name }) => name === 'photoUrl')?.value,
  specSheetUrl: inventory.additionalData.find(({ name }) => name === 'specSheetUrl')?.value,

  km: inventory.vehicleInfo?.km || '0',
  tag: inventory.vehicleInfo?.tag,
  exterior_exact_color: inventory.exteriorColor,
  interior_exact_color: inventory.interiorColor,

  oem_id: inventory.vehicleInfo?.oemId || currentOemId,
  sh_id: inventory.vehicleInfo?.shId || currentShId,
  vmh_id: inventory.vehicleInfo?.vmhId,
  star: +inventory.vehicleInfo?.star || 3,

  engine: inventory.vehicleInfo?.engine,
  tires: inventory.vehicleInfo?.tires,
  transmission: inventory.vehicleInfo?.transmission,
  drive_train: inventory.vehicleInfo?.driveTrain,
  roof: inventory.vehicleInfo?.roof,
  body_style: inventory.vehicleInfo?.bodyStyle,
  keys: inventory.vehicleInfo?.keys,

  warranty_date: inventory.vehicleInfo?.warrantyDate,
  retire_date: inventory.vehicleInfo?.retireDate,
  available_date: inventory.vehicleInfo?.availableDate,

  description: inventory.vehicleInfo?.description,
  accessories: inventory.vehicleInfo?.accessories,

  fuel: inventory.vehicleInfo?.fuel || 8,
  is_prototype: inventory.vehicleInfo?.isPrototype,
  is_redesign: inventory.vehicleInfo?.isRedesign,
  is_new_model: inventory.vehicleInfo?.isNewModel,
});

export const parseInventoryToInventoryForm = (inventory) => ({
  ...inventory,
  modelCode: inventory.modelTrim,
  offlineDate: inventory.offlineDate ? moment(inventory.offlineDate).format("MM-DD-YYYY") : undefined,
  fhiDeparture: inventory.fhiDeparture ? moment(inventory.fhiDeparture).format("MM-DD-YYYY") : undefined,
  vesselEta: inventory.vesselEta ? moment(inventory.vesselEta).format("MM-DD-YYYY") : undefined,

  vehicleInfo: {
    stars: +inventory.vehicleInfo?.star,
  },

  shipTo: inventory.additionalData.find(({ name }) => name === 'shipTo')?.value,
  reasonForOrder: inventory.additionalData.find(({ name }) => name === 'reasonForOrder')?.value,

  photoUrl: inventory.additionalData.find(({ name }) => name === 'photoUrl')?.value,
  specSheetUrl: inventory.additionalData.find(({ name }) => name === 'specSheetUrl')?.value?.split('/vehicleSpecs/')[1]?.split('?')[0],
});